import { Paragraph } from "components/atoms/Typography";
import "./DataCoverage.scss";
import { DataCoverageIcon } from "./DataCoverageIcon";

interface DataCoverageTooltipProps {
    identifier: DataCoverageEnum;
    dataCoverage: DataCoverage;
}

function DataCoverageTooltip({ identifier, dataCoverage }: DataCoverageTooltipProps) {
    const map = buildDataCoverageKeyToTooltipTextMap(dataCoverage);
    const tooltipBodyContent = map[identifier];

    return (
        <Paragraph size="small" style={{ lineHeight: "25px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "inline-block" }}>
                    <DataCoverageIcon identifier={identifier} />
                </div>
                <span data-testid="data-coverage-tooltip--text">
                    {typeof tooltipBodyContent === "string" || tooltipBodyContent.length === 1
                        ? tooltipBodyContent
                        : tooltipBodyContent.map((text, index) => (
                              // eslint-disable-next-line react/no-array-index-key
                              <div key={index}>{`\u2022 ${text}`}</div>
                          ))}
                </span>
            </div>
        </Paragraph>
    );
}

const buildDataCoverageKeyToTooltipTextMap = (dataCoverage: DataCoverage) => ({
    processing: "Processing...",
    error: "Couldn't create energy and emissions profile. Try editing the building. If the problem persists, contact Audette.",
    utility: "Energy data added. Next, add equipment information.",
    utility_warning: "Energy data must match the building energy type.",
    equipment: "Equipment information added. Next, add energy data.",
    equipment_warning: getEquipmentWarnings(dataCoverage),
    equipment_and_utility: "Energy and equipment data added.",
    equipment_and_utility_warning: getEquipmentAndUtilityWarnings(dataCoverage),
    no_equipment_and_no_utility: "Add energy and equipment data to the building profile.",
});

const getEquipmentWarnings = (dataCoverage: DataCoverage) => {
    const warnings = [];
    if (dataCoverage.dataCoverage === "equipment_warning") {
        if (dataCoverage.energyType.replace("_inferred", "") !== dataCoverage.energyTypeFromEquipmentData)
            warnings.push("Equipment data must match the building energy type.");

        if (!dataCoverage.equipmentDataHasSizeAndYear)
            warnings.push("Equipment size and installation years must be defined.");
    }
    return warnings;
};

const getEquipmentAndUtilityWarnings = (dataCoverage: DataCoverage) => {
    const warnings = [];
    if (dataCoverage.dataCoverage === "equipment_and_utility_warning") {
        if (dataCoverage.energyType.replace("_inferred", "") !== dataCoverage.energyTypeFromEquipmentData)
            warnings.push("Equipment data must match the building energy type.");

        if (dataCoverage.energyType.replace("_inferred", "") !== dataCoverage.energyTypeFromUtilityData)
            warnings.push("Energy data must match the building energy type.");

        if (!dataCoverage.equipmentDataHasSizeAndYear)
            warnings.push("Equipment size and installation years must be defined.");
    }
    return warnings;
};

export default DataCoverageTooltip;
